import React from 'react'

type LineSeparatorWithTextProps = {
    /**
     * @default "or"
     */
    text?: string,
}

function LineSeparatorWithText({ text = "or" }: LineSeparatorWithTextProps) {
    return (
        <div className='flex items-center gap-5'>
            <hr className='border-foreground/20 dark:border-foreground/30 grow-[3]' />
            <span className='text-sm text-foreground/20 grow-1'>{text}</span>
            <hr className='border-foreground/20 dark:border-foreground/30 grow-[3]' />
        </div>
    )
}

export default LineSeparatorWithText